// src/features/attendance/services/attendanceService.ts

import api from '../../../api/axios';

import type {
  ApiResponse,
} from '../../../shared/types/api.types';

import type {
  AttendanceRankingResponse,
  GetAttendanceRankingRequest,
} from '../types/attendance.types';

export const attendanceService = {
  /**
   * 지점별 월간 출석 랭킹 조회
   */
  async getAttendanceRanking(
    params:
      GetAttendanceRankingRequest,
  ): Promise<AttendanceRankingResponse> {
    const response =
      await api.get<
        ApiResponse<AttendanceRankingResponse>
      >(
        '/admin/attendance/ranking',
        {
          params,
        },
      );

    return response.data.data;
  },
};